<template>
  <div :class="previewUploaded ? 'preview-uploaded' : 'no-preview-uploaded'">
    <div class="[ upload-file-avatar ] position-absolute">
      <div class="[ upload-has-avatar-wrap ]">
        <div class="position-absolute d-flex flex-column">
          <div class="text-center">
            <i v-if="inputType == 'add'" class="fa-regular fa-image fa-lg text-white text-center"></i>
            <i v-else class="fa-regular fa-image fa-lg text-white text-center"></i>
          </div>
          <p class="mb-0 text-center">{{inputType == 'add' ? 'Add' : 'Replace' }} Image</p>
        </div>

        <img
          v-if="imageUrl"
          :src="imageUrl"
          width="132"
          height="132"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      previewUploaded: {
        type: Boolean,
      },
      inputType: {
        type: String,
      },
      imageUrl: {
        type: String,
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>